export default {
  type: 'select',
  name: 'enumField', // This should be overridden
  label: 'global.text.select', // This should be overridden
  locale: true,
  labelInValue: false,
  allowClear: true,
  // Enum-specific properties that should be overridden
  isEnum: true,
  enumNamespace: '', // This should be overridden
  enumSource: null, // This should be overridden
  options: [], // This should be overridden
};
